import { useTranslation } from "react-i18next";

export const TransferredEmployeePercentageTooltip = () => {
  const { t } = useTranslation("components");

  return (
    <div className="max-w-[420px] text-sm flex flex-col gap-2">
      <p>{t("customtooltips.transferredemployeepercentage.description")}</p>

      <div className="flex flex-col gap-1">
        <p className="font-semibold">
          {t("customtooltips.transferredemployeepercentage.onboardingbriefing.title")}
        </p>
        <p>{t("customtooltips.transferredemployeepercentage.onboardingbriefing.description")}</p>
        <p className="text-xs px-2 py-1 bg-muted rounded-md">
          {t("customtooltips.transferredemployeepercentage.onboardingbriefing.formula")}
        </p>
        <p>{t("customtooltips.transferredemployeepercentage.onboardingbriefing.impact")}</p>
      </div>

      <div className="flex flex-col gap-1">
        <p className="font-semibold">
          {t("customtooltips.transferredemployeepercentage.vacationentitlement.title")}
        </p>
        <p>{t("customtooltips.transferredemployeepercentage.vacationentitlement.description")}</p>
        <p className="text-xs px-2 py-1 bg-muted rounded-md">
          {t("customtooltips.transferredemployeepercentage.vacationentitlement.formula")}
        </p>
        <p>{t("customtooltips.transferredemployeepercentage.vacationentitlement.impact")}</p>
      </div>
    </div>
  );
};

export const AverageLengthOfEmploymentTooltip = () => {
  const { t } = useTranslation("components");

  return (
    <div className="w-[420px] text-sm flex flex-col gap-2">
      <p>{t("customtooltips.averagelengthofemployment.description")}</p>

      <div className="flex flex-col gap-1">
        <p className="font-semibold">{t("customtooltips.averagelengthofemployment.howitsused.title")}</p>
        <p>{t("customtooltips.averagelengthofemployment.howitsused.description")}</p>
        <p className="text-xs px-2 py-1 bg-muted rounded-md">
          {t("customtooltips.averagelengthofemployment.howitsused.formula")}
        </p>
        <p>{t("customtooltips.averagelengthofemployment.howitsused.impact")}</p>
      </div>
    </div>
  );
};
